<template>
  <div
    class="image-container"
    :class="[
      content.titlePosition === 'top' ? 'image-title-top' : '',
      device.isMobile ? 'image-container-mobile' : ''
    ]"
    :id="content.key"
  >
    <div
      class="image-box"
      :class="[
        content.hasBack === 1 ? 'image-box-has-back' : '',
        content.heightNoLimit === 1 ? 'image-box-no-limit-height' : ''
      ]"
      :id="`${content.key}-1`"
    >
      <el-image
        class="image"
        :id="`${content.key}-1-1`"
        :src="content.url"
        :preview-src-list="[content.url]"
        :style="{
          maxWidth: content.maxWidth ? content.maxWidth + 'rem' : ''
        }"
        @click="(e) => {
          findChapterFrom(e)
          e.stopPropagation()
        }"
      ></el-image>
    </div>
    <p
      class="image-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.titleStyle.fontFamily || '',
        fontSize: (content.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.titleStyle.fontWeight || '',
        textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.titleStyle.textAlign || '',
        color: content.titleStyle.color || '',
        backgroundColor: content.titleStyle.backgroundColor || '',
      }"
      v-html="content.title"
    ></p>
    <p class="image-title image-subtitle" :id="`${content.key}-3`" v-if="content.subtitle">{{ content.subtitle }}</p>
  </div>
</template>

<script>
/*
单个图片样式
*/
export default {
  name: "imageUnit",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.image-container {
  width: 100%;
  position: relative;

  .image-box{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 10rem;

    .image{
      display: block;
      max-height: 380rem;
      max-width: 100%;

      /deep/.el-image__inner{
        max-height: 380rem;
        max-width: 100%;
      }
    }
  }

  .image-box-has-back{
    background: #fff;
    border: 1rem solid #939DA4;
    padding: 20rem;
    min-height: 200rem;
  }

  .image-box-no-limit-height{
    .image{
      max-height: none;
      /deep/.el-image__inner{
        max-height: none;
      }
    }
  }

  .image-title{
    display: block;
    margin-bottom: 10rem;
    width: 100%;
    text-align: center;
    font-size: 16rem;
    line-height: 20rem;
    color: #666;
  }

  .image-subtitle{
    width: auto;
    position: absolute;
    top: auto;
    bottom: 0;
    right: 0;
    left: auto;
    margin-bottom: 0;
    font-size: 14rem;
    color: #999;
  }
}
.image-container-mobile{
  .image-title{
    font-size: 20rem;
    line-height: 32rem;
  }
  .image-subtitle{
    font-size: 18rem;
  }
}
.image-title-top{
  padding-top: 52rem;
  position: relative;
  margin-top: 20rem;

  .image-title{
    position: absolute;
    top: 0;
    left: 0;
  }

  .image-subtitle{
    width: auto;
    position: absolute;
    top: 0;
    bottom: auto;
    right: 0;
    left: auto;
    margin-top: 2rem;
  }
}
</style>